import Nullstack from 'nullstack';
export default function IconTorii({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-torii",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 4c5.333 1.333 10.667 1.333 16 0"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h16"
  }), "   ", Nullstack.element("path", {
    d: "M12 5v3"
  }), "   ", Nullstack.element("path", {
    d: "M18 4.5v15.5"
  }), "   ", Nullstack.element("path", {
    d: "M6 4.5v15.5"
  }), " ");
}